/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation AccessTokenGenerateMutation($bindToTable: String!, $bindableId: ID!) {
    AccessTokenGenerate(bindToTable: $bindToTable, bindableId: $bindableId) {
      token,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
